import InfoIcon from '@mui/icons-material/Info';
import { Typography, Box, Button } from '@mui/material';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useAppSelector } from 'redux/storeHooks';
import { selectSelectedTeamMemberId } from 'redux/slices/selectedMemberSlice.slice';
import { selectActingUser } from 'redux/slices/actingUserSlice.slice';
import { userAppSelectors } from 'redux/slices/usersSlice.slice';

const ViewAsBanner = () => {
  try {
    const teamMemberId = useAppSelector(selectSelectedTeamMemberId);
    const actingUser = useAppSelector(selectActingUser);
    const navigate = useNavigate();
    const location = useLocation();
    const { memberId: routeMemberId } = useParams();

    const teamMember = userAppSelectors.useSelectUserById(teamMemberId || '');

    if (!actingUser) {
      return null;
    }

    const currentPage = location.pathname.split('/')[1] || '';

    const switchToMyView = () => {
      try {
        if (actingUser?.id) {
          navigate(`/docket/guide/${actingUser.id}`);
        } else {
          navigate('/docket');
        }
      } catch (error) {
        console.warn('Navigation error:', error);
        navigate('/docket');
      }
    };

    // Show banner conditions:
    // 1. We have an acting user and team member data
    // 2. We're viewing as someone other than ourselves
    // 3. We're on docket or member-list page
    const shouldShowBanner =
      actingUser &&
      teamMember &&
      teamMemberId &&
      teamMemberId !== 'none' &&
      teamMemberId !== actingUser.id &&
      (currentPage === 'docket' ||
        (currentPage === 'member-list' && routeMemberId));

    if (!shouldShowBanner) {
      return null;
    }

    const viewingText = teamMember
      ? `You are viewing as ${teamMember.firstName} ${teamMember.lastName}`
      : 'This member is not assigned to a guide';

    return (
      <Box
        sx={{
          backgroundColor: '#dce4e8',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '14px',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <InfoIcon sx={{ marginRight: '10px' }} />
          <Typography variant="bodyMedium">{viewingText}</Typography>
        </Box>
        <Button
          variant="text"
          onClick={switchToMyView}
          sx={{ textTransform: 'none' }}
        >
          <Typography variant="labelLarge">Switch to my view</Typography>
        </Button>
      </Box>
    );
  } catch (error) {
    console.warn('ViewAsBanner error:', error);
    return null;
  }
};

export default ViewAsBanner;
